// extracted by mini-css-extract-plugin
module.exports = {"link":"IndexesBtn_link__OB0dJ"};